import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface DataTableButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

export const DataTableButton = ({
  children,
  onClick,
  disabled,
}: DataTableButtonProps) => {
  return (
    <Button
      variant="secondary"
      size="sm"
      className={cn(
        "m-1 py-1 px-2 text-xs size-auto hover:bg-slate-300 cursor-not-allowed",
        {
          "opacity-75 cursor-not-allowed": disabled,
        },
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default DataTableButton;
